import React from 'react';
import Body from '../Body/Body';
import '../Style.css'


const Home = () => {
    return (
        <div className=" home">
            <Body></Body>
        </div>
    );
};

export default Home;